import { render, staticRenderFns } from "./addModule.vue?vue&type=template&id=051a71bc&scoped=true"
import script from "./addModule.vue?vue&type=script&lang=js"
export * from "./addModule.vue?vue&type=script&lang=js"
import style0 from "./addModule.vue?vue&type=style&index=0&id=051a71bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a71bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('051a71bc')) {
      api.createRecord('051a71bc', component.options)
    } else {
      api.reload('051a71bc', component.options)
    }
    module.hot.accept("./addModule.vue?vue&type=template&id=051a71bc&scoped=true", function () {
      api.rerender('051a71bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/components/addModule.vue"
export default component.exports